import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { Student } from '@app/models/users'
import { Helmet } from 'react-helmet'
import { AbilityContext } from '@app/context/ability-context'
import { defineStudentAbilities, authorize } from '@app/ability'
import { statePath } from '@app/helpers/studentsHelper'

class StudentPlayerLayout extends Component {
  render() {
    const Component = this.props.component
    const { student, route, global } = this.props
    const ability = defineStudentAbilities(student, global)

    if (!authorize(ability, Component)) {
      return <Redirect to={statePath(ability)} />
    }

    return (
      <AbilityContext.Provider value={ability}>
        <Helmet>
          <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1, maximum-scale=1" />
        </Helmet>

        <div className="layout layout--public layout--forced-landscape" >
          <Component student={student} route={route} global={global} />
        </div>
      </AbilityContext.Provider>
    )
  }
}

StudentPlayerLayout.propTypes = {
  student: PropTypes.instanceOf(Student).isRequired,
  global: PropTypes.object.isRequired
}

export default StudentPlayerLayout
